import React from 'react';
import './Banner.css';
import images from '../../../constants/images';
import { useTranslation } from 'react-i18next';

const Banner = () => {
  const { t } = useTranslation();

  return (
    <div className="app__banner">
      <div className="app__banner-bg-overlay"></div>
      <div className="app__banner-container">
        <div className="app__banner-content">
          <div className="app__banner-image-primary">
            <div className="app__banner-image-wrapper">
              <img src={images.hall} alt="Restaurant Hall" />
              <div className="app__banner-image-glow"></div>
            </div>
          </div>

          <div className="app__banner-text">
            <div className="app__banner-text-wrapper">
              <h2 className="app__banner-title">
                <span className="app__banner-title-main">
                  {t('banner_section.title_main')}
                </span>
                <span className="app__banner-title-accent">
                  {t('banner_section.title_accent')}
                </span>
              </h2>

              <div className="app__banner-divider">
                <img src={images.spoon} alt="Decorative Spoon" className="app__banner-spoon" />
              </div>

              <p className="app__banner-description">
                {t('banner_section.description')}
              </p>

              <div className="app__banner-cta">
                <button className="app__banner-btn" onClick={(e) => { e.preventDefault(); window.location.href = '/#booking'} }>
                  {t('banner_section.button')}
                </button>
              </div>
            </div>
          </div>

          <div className="app__banner-image-secondary">
            <div className="app__banner-image-wrapper">
              <img src={images.hall_door} alt="Restaurant Entrance" />
              <div className="app__banner-image-glow"></div>
            </div>
          </div>
        </div>

        <div className="app__banner-logo">
          <div className="app__banner-logo-wrapper">
            <img src={images.logo_wall} alt="Restaurant Logo" />
            <div className="app__banner-logo-shine"></div>
          </div>
        </div>
      </div>

      <div className="app__banner-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
    </div>
  );
};

export default Banner;
